import { RoleModel } from "../models/RoleModel";
import API, { client } from "./API";

const RoleService = {
  async getAllRoles() {
    const response = await API().get("Role", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularRole(role_id: number) {
    const response = await API().get("Role");
    return response.data.filter(
      (cur_role: RoleModel) => cur_role.roleId === role_id
    )[0];
  },
  async createRole(data: RoleModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Role/${id}` : "Role",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default RoleService;
